import React from "react";
import "../../style/dots.css";
import { DOTS, MEDIUM} from "../../helpers/constants";
import { Loader } from 'arag-ui-lib';

const OverlayIndicator = (props) =>{
    const {
        fetching,
        wholePage
    } = props
    if(fetching){
        return (
            <div id={wholePage ? 'overlayWholePage':'overlay'}>
                <div id="overlayText">
                    <Loader variant={DOTS} dotSize={MEDIUM} />
                </div>
            </div>
        );
    }
    return (null);
};

export default OverlayIndicator;

